import { PlusCircle } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { WhereaboutsModal } from "shared/components";
import { Flex } from "styled-system/jsx";
import {
  NewWidgetStep,
  useStartNewWidgetModal,
} from "./useStartNewWidgetModal";
import { StartNewOperatorWidget } from "./StartNewOperatorWidget/StartNewOperatorWidget";
import { WidgetTypeSelection } from "./WidgetTypeSelection";
import { StartNewEventWidget } from "./StartNewEventWidget/StartNewEventWidget";
import {
  EnumWidgetEventSettingsDisplayType,
  EnumWidgetType,
} from "gql/generated";

type StartNewWidgetModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onNextClick: (
    widgetType: EnumWidgetType,
    name: string,
    listId?: string,
    eventSettings?: {
      displayType: EnumWidgetEventSettingsDisplayType;
      lookAheadMonths: number;
      eventTags: string[];
    },
  ) => void;
  loadingCreate?: boolean;
};

export const StartNewWidgetModal = ({
  isOpen,
  onClose,
  onNextClick,
  loadingCreate,
}: StartNewWidgetModalProps) => {
  const { t } = useTranslation("widgets");

  const {
    step,
    setStep,
    modalTitle,
    onCloseClick,
    setOnCloseClick,
    cancelButtonProps,
    setCancelButtonProps,
    nextButtonProps,
    setNextButtonProps,
  } = useStartNewWidgetModal({ isOpen, onClose });

  return (
    <WhereaboutsModal
      isOpen={isOpen}
      onClose={onCloseClick}
      title={modalTitle}
      HeaderIcon={PlusCircle}
      cancelButtonProps={cancelButtonProps}
      saveButtonCopy={t("core:NEXT")}
      saveButtonProps={{
        isLoading: loadingCreate,
        ...nextButtonProps,
      }}
      size={"md"}
    >
      <Flex flexDir={"column"} gap={"250"}>
        {step === NewWidgetStep.SelectWidgetType ? (
          <WidgetTypeSelection setStep={setStep} />
        ) : step === NewWidgetStep.SelectedOperator ? (
          <StartNewOperatorWidget
            setOnCloseClick={setOnCloseClick}
            setCancelButtonProps={setCancelButtonProps}
            setNextButtonProps={setNextButtonProps}
            onClose={onClose}
            onNextClick={onNextClick}
          />
        ) : step === NewWidgetStep.SelectedEvent ? (
          <StartNewEventWidget
            setOnCloseClick={setOnCloseClick}
            setCancelButtonProps={setCancelButtonProps}
            setNextButtonProps={setNextButtonProps}
            onClose={onClose}
            onNextClick={onNextClick}
          />
        ) : null}
      </Flex>
    </WhereaboutsModal>
  );
};
